import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { exportTableToPDF } from "./utils/exportPDF";

const ExpenditureListKitchen = () => {
  const [kitchenId, setKitchenId] = useState("");
  const [requisitionList, setRequisitionList] = useState([]);
  const [filterDate, setFilterDate] = useState("");
  const [filterDateend, setFilterDateend] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [appliedSearchTerm, setAppliedSearchTerm] = useState("");

  const itemsPerPage = 10;

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user"));
    if (user?.kitchen) {
      setKitchenId(user.kitchen);
    }
  }, []);

  useEffect(() => {
    if (kitchenId) fetchRequisitionList();
  }, [kitchenId]);

  const fetchRequisitionList = async (start_date = "", end_date = "") => {
    let url = `https://ims-backend.indevconsultancy.in/api/daily-expendituress/${kitchenId}/`;
    if (start_date && end_date) {
      url += `?start_date=${start_date}&end_date=${end_date}`;
    }
    try {
      const res = await axios.get(url);
      if (res.data) {
        setRequisitionList(res.data);
        setCurrentPage(1);
      }
    } catch (err) {
      console.error("Failed to fetch requisition list:", err);
    }
  };

  // const handleSearch = (e) => {
  //   e.preventDefault();
  //   const start_date = filterDate
  //     ? new Date(filterDate).toISOString().split("T")[0]
  //     : "";
  //   const end_date = filterDateend
  //     ? new Date(filterDateend).toISOString().split("T")[0]
  //     : "";

  //   fetchRequisitionList(start_date, end_date);
  // };

  const handleSearch = (e) => {
    e.preventDefault();
    const start_date = filterDate
      ? new Date(filterDate).toISOString().split("T")[0]
      : "";
    const end_date = filterDateend
      ? new Date(filterDateend).toISOString().split("T")[0]
      : "";

    setAppliedSearchTerm(searchTerm); // Apply search on submit
    fetchRequisitionList(start_date, end_date);
  };

  // const handleExportCSV = () => {
  //   const headers = ["S.No.", "Item Name", "Quantity", "Expenditure Date"];
  //   const rows = requisitionList.map((item, index) => [
  //     index + 1,
  //     `${item.stock_name} (${item.units})`,
  //     item.expenditure_quantity,
  //     formatDate(item.created_at),
  //   ]);

  //   const csvContent =
  //     "data:text/csv;charset=utf-8," +
  //     [headers, ...rows]
  //       .map((row) =>
  //         row
  //           .map((field) =>
  //             typeof field === "string" && field.includes(",")
  //               ? `"${field}"`
  //               : field
  //           )
  //           .join(",")
  //       )
  //       .join("\n");

  //   const encodedUri = encodeURI(csvContent);
  //   const link = document.createElement("a");
  //   link.setAttribute("href", encodedUri);
  //   link.setAttribute("download", "expenditure_list.csv");
  //   document.body.appendChild(link);
  //   link.click();
  //   document.body.removeChild(link);
  // }; 

  const handleExportCSV = () => {
    const headers = ["S.No.", "Item Name", "Sub Kitchen", "Meal Type", "Quantity","Price","Amount", "Expenditure Date", "Remark"];
    const rows = filteredList.map((item, index) => [
      index + 1,
      `${item.stock_name} (${item.units})`,
      item.sub_kitchen_name || "-",
      item.meal_type || "-",
      item.expenditure_quantity,
      item.price,
      item.amount,
      formatDate(item.created_at),
      (item.remarks || "").toString().replace(/,/g, " "),
    ]);

    const csvContent =
      "data:text/csv;charset=utf-8," +
      [headers, ...rows]
        .map((row) =>
          row
            .map((field) =>
              typeof field === "string" && field.includes(",")
                ? `"${field}"`
                : field
            )
            .join(",")
        )
        .join("\n");

    const encodedUri = encodeURI(csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", "expenditure_list_filtered.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleExportPDF = () => {
    const headers = ["S.No.", "Item Name", "Sub Kitchen", "Meal Type", "Quantity", "Price", "Amount", "Expenditure Date", "Remark"];
    const rows = filteredList.map((item, index) => [
      index + 1,
      `${item.stock_name} (${item.units})`,
      item.sub_kitchen_name || "-",
      item.meal_type || "-",
      item.expenditure_quantity,
      item.price,
      item.amount,
      formatDate(item.created_at),
      item.remarks || "-",
    ]);
    exportTableToPDF({
      title: "Expenditure List Report",
      headers,
      rows,
      filename: "expenditure_list_filtered.pdf",
      filterInfo: `Total: ${rows.length}`,
    });
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const filteredList = requisitionList.filter((item) =>
    item.stock_name.toLowerCase().includes(appliedSearchTerm.toLowerCase())
  );

  const totalPages = Math.ceil(filteredList.length / itemsPerPage);

  const paginatedList = filteredList.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  return (
    <div className="container-fluid px-2">
      {/* Header */}
      <div className="row align-items-center justify-content-between py-2">
        <div className="col-md-6 col-6">
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb justify-content-start mb-0">
              <li className="breadcrumb-item">
                <Link to="/mobilehome">Home</Link>
              </li>
            </ol>
          </nav>
        </div>
        <div className="col-md-6 col-6 text-end">
          <span className="fs-1">Expenditure List</span>
        </div>
      </div>

      {/* Filter Section */}
      <div className="card">
        <div className="card-header border-info">
          <form onSubmit={handleSearch}>
            <div className="row g-3">
              <div className="col-lg">
                <label htmlFor="startDate">Start Date</label>
                <input
                  type="date"
                  id="startDate"
                  className="form-control"
                  value={filterDate}
                  onChange={(e) => setFilterDate(e.target.value)}
                />
              </div>
              <div className="col-lg">
                <label htmlFor="endDate">End Date</label>
                <input
                  type="date"
                  id="endDate"
                  className="form-control"
                  value={filterDateend}
                  onChange={(e) => setFilterDateend(e.target.value)}
                />
              </div>

              <div className="col-lg">
                <label>Item Name</label>
                <input
                  type="text"
                  // id="endDate"
                  className="form-control"
                  placeholder="Enter Item Name"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </div>
              <div className="col-lg-2 mt-5">
                <button type="submit" className="btn btn-primary w-100">
                  Search
                </button>
              </div>
              <div className="col-lg-1 mt-5">
                <button
                  type="button"
                  className="btn btn-outline-dark w-100"
                  onClick={() => {
                    setFilterDate("");
                    setFilterDateend("");
                    setSearchTerm(""); // Clear the input box
                    setAppliedSearchTerm(""); // Clear the actual search used in filtering
                    fetchRequisitionList(); // Reload full data
                  }}
                >
                  Reset
                </button>
              </div>
            </div>
          </form>
        </div>

        {/* Table Section */}
        <div className="card-body">
          <div className="row g-0 align-items-center mb-3">
            <div className="col-sm-4">
              <h6 className="fw-bold mb-0">
                Total Item(s): <span>{filteredList.length}</span>
              </h6>
            </div>
            {/* <div className="col-sm-4">
              <input
                type="text"
                className="form-control"
                placeholder="Search Item Name"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div> */}
            {/* <div className="col-sm-4 text-end">
              <Link to="/expenditure" className="btn btn-primary">
                Add <i className="fas fa-plus"></i>
              </Link>
              <button
                className="btn ms-2 btn-primary"
                onClick={handleExportCSV}
              >
                <i className="fas fa-file-csv"></i> Export CSV
              </button>
            </div> */}

            <div className="col-sm-8 text-end">
              <div className="d-flex justify-content-end gap-2">
                <Link to="/expenditure" className="btn btn-primary">
                  Add <i className="fas fa-plus"></i>
                </Link>
                <button className="btn btn-primary" onClick={handleExportCSV}>
                  <i className="fas fa-file-csv"></i> Export CSV
                </button>
                <button className="btn btn-danger" onClick={handleExportPDF}>
                  <i className="fas fa-file-pdf"></i> Export PDF
                </button>
              </div>
            </div>
          </div>

          <div className="table-responsive">
            <table className="table table-bordered text-center fs--1 mb-0">
              <thead className="bg-primary text-white">
                <tr>
                  <th>Expenditure-ID</th>
                  <th>Item Name</th>
                  <th>Sub Kitchen</th>
                  <th>Meal Type</th>
                  <th>Remark</th>
                  <th>Quantity</th>
                  <th>Price</th>
                  <th>Amount</th>
                  <th>Expenditure Date</th>
                </tr>
              </thead>
              <tbody>
                {paginatedList.length === 0 ? (
                  <tr>
                    <td colSpan="9">No data available</td>
                  </tr>
                ) : (
                  paginatedList.map((item, index) => (
                    <tr key={index}>
                      <td>EX00{item.dailyexpenditure_id}</td>
                      <td>
                        {item.stock_name} ({item.units})
                      </td>
                      <td>{item.sub_kitchen_name || "-"}</td>
                      <td>{item.meal_type || "-"}</td>
                      <td>
                        {item.remarks && String(item.remarks).trim() !== ""
                          ? item.remarks
                          : "-"}
                      </td>
                      <td>{item.expenditure_quantity}</td>
                      <td>{item.price}</td>
                      <td>{item.amount}</td>
                      <td>{formatDate(item.created_at)}</td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>

          {/* Pagination */}
          <div className="d-flex justify-content-between align-items-center mt-3">
            <button
              className="btn btn-outline-primary btn-sm"
              onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
              disabled={currentPage === 1}
            >
              Previous
            </button>
            <span>
              Page {currentPage} of {totalPages}
            </span>
            <button
              className="btn btn-outline-primary btn-sm"
              onClick={() =>
                setCurrentPage((prev) => Math.min(prev + 1, totalPages))
              }
              disabled={currentPage === totalPages}
            >
              Next
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExpenditureListKitchen;
